/* eslint-disable no-nested-ternary, no-confusing-arrow */
import CONST_STORAGE from 'constants/storage';
import AUTH from 'constants/auth';
import { getStorageWebUserData } from 'helpers/webUser';
import { withMockModules } from 'helpers/mockModules';

export const isAuthenticated = () =>
  localStorage.getItem(CONST_STORAGE.USERS.CURRENT_USER_TOKEN) !== null;

export const getToken = () =>
  localStorage.getItem(CONST_STORAGE.USERS.CURRENT_USER_TOKEN);

export const setToken = (token) =>
  localStorage.setItem(
    CONST_STORAGE.USERS.CURRENT_USER_TOKEN,
    `Bearer ${token}`,
  );

export const getId = () =>
  localStorage.getItem(CONST_STORAGE.USERS.CURRENT_USER_ID);

export const setId = (id) =>
  localStorage.setItem(CONST_STORAGE.USERS.CURRENT_USER_ID, `${id}`);

export const getLoggedAsSchool = () =>
  localStorage.getItem(CONST_STORAGE.USERS.SCHOOL_IS_LOGGED);

export const setLoggedAsSchool = (status) =>
  localStorage.setItem(CONST_STORAGE.USERS.SCHOOL_IS_LOGGED, status);

export const setClaims = (claims) =>
  localStorage.setItem(
    CONST_STORAGE.USERS.CURRENT_USER_CLAIMS,
    JSON.stringify(claims),
  );

export const getClaims = () =>
  localStorage.getItem(CONST_STORAGE.USERS.CURRENT_USER_CLAIMS);

export const setCompany = (company) =>
  localStorage.setItem('BdosCompanyId', company);

export const getCompany = () => localStorage.getItem('BdosCompanyId');

export const setUserType = (type) => localStorage.setItem('UserType', type);

export const getUserType = () => localStorage.getItem('UserType');

export const setAttendantUsername = (name) =>
  localStorage.setItem('AttendantUsername', name);

export const getAttendantUsername = () =>
  localStorage.getItem('AttendantUsername');

export const setMessagingToken = (token) =>
  localStorage.setItem('messagingToken', token);

export const getMessagingToken = () => localStorage.getItem('messagingToken');

// Obtém os módulos do SupervisorOperator do transportOperator selecionado
const getSupervisorOperatorModules = () => {
  try {
    const webUserData = JSON.parse(getStorageWebUserData());
    const companyId = getCompany();

    if (webUserData?.TransportOperators && companyId) {
      const selectedOperator = webUserData.TransportOperators.find(
        (op) => op.id === companyId,
      );

      if (selectedOperator?.SupervisorOperator?.modules) {
        return JSON.parse(selectedOperator.SupervisorOperator.modules);
      }
    }
  } catch (e) {
    // Em caso de erro, retorna array vazio para usar fallback
  }
  return [];
};

export const isAuthorized = (
  modules = [],
  types = [],
  all = false,
  isConsortion = false,
  isCompany = false,
  moduleConsortionHasAutorization = true,
) => {
  const currentUserType = getUserType();

  // Tenta usar os módulos do SupervisorOperator primeiro
  const supervisorModules = getSupervisorOperatorModules();

  let userModules = [];

  if (supervisorModules.length > 0) {
    // Usa os módulos do SupervisorOperator
    userModules = supervisorModules;
  } else {
    // Fallback: usa os módulos das claims
    const claims = JSON.parse(getClaims());
    let ownModules = claims ? claims.types : [];
    const selectedModule = ownModules.find(
      (e) => e.type.toUpperCase() === currentUserType.toUpperCase(),
    );

    if (selectedModule) {
      userModules = selectedModule.modules || [];
    }
  }

  // mockModules: temporary local-testing mock, see helpers/mockModules.ts
  userModules = withMockModules(userModules);

  // If the user has and is logged in the required type
  const hasType = types && types.includes(currentUserType?.toUpperCase() || '');

  // If the user has all the modules
  const allModules = all
    ? modules.every(
        (mod) =>
          userModules?.includes(mod) ||
          userModules?.includes(getOldModule(mod)),
      )
    : modules.some(
        (mod) =>
          userModules?.includes(mod) ||
          userModules?.includes(getOldModule(mod)),
      );

  if (isConsortion) {
    return hasType && allModules && moduleConsortionHasAutorization;
  }
  if (isCompany) return true;

  return hasType && allModules;
};

export const getOldModule = (mod) => {
  for (const item of AUTH.MODULOS_MANEGEMENT) {
    if (item) {
      // eslint-disable-next-line no-restricted-syntax
      for (const subItem of item.modules) {
        if (subItem) {
          if (subItem.key === mod) {
            return subItem.oldKey;
          }
        }
      }
    }
  }
  return '';
};
